/*
 * -----------------------------------------------------------------------------------------
 * Loading.tsx
 *
 * Copyright: (c) 2004-2022 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 17.05.2022
 * Autor    : Jonas Wessel
 *
 * Geändert : 04.10.2022
 *      von : Jonas Wessel
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */
import { Loader } from "semantic-ui-react";
import "semantic-ui-css/components/loader.min.css";
import React from "react";
import logo from "assets/pp_logo.jpg";

interface LoadingProps {
    message?: string;
}
const Loading = (props: LoadingProps) => {
    return (
        <div style={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
            color: "#333 !important", fontSize: "1rem !important",
            lineHeight: "1 !important"//, fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif"
        }}>
            <div style={{position: "relative", height: "2rem" }}>
                <Loader active />
                <img src={logo} />

            </div>
            {props.message && <div style={{paddingTop: "16px"}}>{props.message}</div>}
        </div>
    );
};
export default Loading;
